import React from 'react';

import RosterIndex from '../../components/user/RosterIndex';
import PageLayout from '../../components/layout/PageLayout';

const RosterPage = () => {
  return (
    <PageLayout>
      <RosterIndex />
    </PageLayout>
  );
};

export default RosterPage;
